<template>
    <div v-if="pagination.totalItem > 0 && Math.ceil(pagination.totalItem/pagination.pageSize) > 1" :key="key" class="text-center" data-qa="pagination">
    <!-- <div :key="key" class="text-center" data-qa="pagination"> -->
      <div class="pagination">
        <div class="flex-between">
          <!-- lest -->
          <div class="p-t-8">
            <div v-if="isMobile" class="flex p-t-8" :class="{'p-b-12' : isMobile}">
              <div class="page-box">
                <!-- <input type="text" v-model="currentPage" @keydown="enterSearch" @blur="onBlur" data-qa="txt-field-search"> -->
                <input v-model="currentPage" class="page-input" type="number" data-qa="txt-field-search" pattern="[0-9]+" @keydown.enter="onChangePageInput($event)" @blur="onChangePageInput($event)">
              </div>
              <span class="m-l-8">of {{ totalPage }}</span>
            </div>
            <div>{{ summaryItem }}</div>
          </div>
          <!-- middle -->
          <div v-if="!isMobile" class="flex p-t-8">
            <span class="m-r-8">Page</span>
            <div class="page-box">
              <!-- <input type="text" v-model="currentPage" @keydown="enterSearch" @blur="onBlur" data-qa="txt-field-search"> -->
              <input v-model="currentPage" class="page-input" type="number" data-qa="txt-field-search" pattern="[0-9]+" @keydown.enter="onChangePageInput($event)" @blur="onChangePageInput($event)">
            </div>
            <span class="m-l-8">of {{ totalPage }}</span>
          </div>
          <!-- right -->
          <div v-if="!isMobile" class="flex">
            <CncButton :name="$t('previous')" type="ghost" size="medium" :leftIcon="{type: 'icon', name: 'ico_chevron_left'}" :disabled="currentPage == 1" @click="prevPageButton" />
            <CncButton :name="$t('next')" type="ghost" size="medium" :rightIcon="{type: 'icon', name: 'ico_chevron_right'}" :disabled="currentPage == totalPage" @click="nextPageButton" />
          </div>
          <div v-else class="flex gap-12">
            <CncIconButton type="neutral" size="medium" :iconName="{type: 'icon', name: 'ico_chevron_left'}" :disabled="currentPage == 1" @click="prevPageButton" />
            <CncIconButton type="neutral" size="medium" :iconName="{type: 'icon', name: 'ico_chevron_right'}" :disabled="currentPage == totalPage" @click="nextPageButton" />
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  props: {
    pagination: { type: Object, default () { return this.$store.state.pagination } },
    isStore: { type: Boolean, default: true },
    showLess: { type: Boolean }
  },
  data () {
    return {
      // กรณีใช้จาก $store ไม่ควร :current-page="pagination.currentPage" ไปโดยตรง เพราะเมื่อเปลี่ยนไปเมนูอื่นที่มีการ getList จะทำให้ this.$store.state.pagination.currentPage ถูกเซ็ตเป็น 1 ทำให้ component Pagination @current-change เกิดการทำงานอีกครั้ง ทำให้ path จะถูกเปลี่ยนกลับมาที่ path เดิมแต่ page = 1
      currentPage: parseInt(this.pagination.currentPage),
      // กรณีใช้จาก $store ไม่ควร :page-size="pagination.pageSize" :total="pagination.totalItem" ไปโดยตรง เพราะเมื่อเปลี่ยนไปเมนูอื่นที่มีการ getList แล้วมี page ที่น้อยกว่า เช่น จาก provider หน้า 3 ไป category หน้า 2 จะทำให้ el-pagination เคลื่อน currentPage ไปยังหน้า 2 (เพราะมันมองว่าไม่มีหน้า 3) ทำให้ @current-change เกิดการทำงานอีกครั้ง ทำให้ path จะถูกเปลี่ยนกลับมาที่ path เดิมแต่ page = หน้าที่มากสุด
      pageSize: parseInt(this.pagination.pageSize),
      totalItem: parseInt(this.pagination.totalItem),
      summaryItem: 0
    }
  },
  computed: {
    key () {
      // เมื่อมีการ getList จะทำให้ $store.state.pagination.key เปลี่ยน ใส่ key ไว้ที่ template ให้ render component pagination ใหม่
      return this.pagination.key
    },
    isMobile () {
      return this.$store.state.windowWidth <= 768
    },
    totalPage () {
      return this.pagination.totalItem > 0 && Math.ceil(this.pagination.totalItem / this.pagination.pageSize)
    }
  },
  // (this.currentPage * this.pageSize) + (this.totalItem % this.pageSize)
  watch: {
    'key' (val) {
      if (this.isStore) {
        this.currentPage = parseInt(this.pagination.currentPage)
        this.pageSize = parseInt(this.pagination.pageSize)
        this.totalItem = parseInt(this.pagination.totalItem)
      }
    },
    'pagination.currentPage' (val) {
      if (!this.isStore) this.currentPage = parseInt(val)
    },
    'pagination.pageSize' (val) {
      if (!this.isStore) this.pageSize = parseInt(val)
    },
    'pagination.totalItem' (val) {
      if (!this.isStore) this.totalItem = parseInt(val)
    },
  },
  mounted () {
    this.countItem()
  },
  methods: {
    onChangePage (val) {
      // จะต้องทำงานเมื่อคลิกที่ตัวเลขใน el-pagination เท่านั้น
      this.currentPage = val
      if (this.isStore) {
        this.$router.push({ query: Object.assign(Object.assign({}, this.$route.query), { page: val }) })
        setTimeout(() => {
          this.$store.commit('SET_STATE', { name: 'countChangePage', val: this.$store.state.countChangePage + 1 })
          this.$emit('change', { page: this.$store.state.countChangePage })
        }, 50)
      } else {
        this.$emit('change', { page: val })
      }
      this.countItem()
    },
    onChangePageInput (e) {
      let targetPage = parseInt(e.target.value)
      this.onChangePage(targetPage > this.totalPage ? this.totalPage : targetPage)
    },
    nextPageButton () {
      let next = this.currentPage + 1
      this.onChangePage(next)
    },
    prevPageButton () {
      let next = this.currentPage - 1
      this.onChangePage(next)
    },
    countItem () {
      this.summaryItem = `${(this.currentPage * this.pageSize) - (this.pageSize - 1)} - ${this.currentPage === this.totalPage ? this.totalItem : (this.currentPage * this.pageSize)} of ${this.totalItem} items`
    }
  }
}
</script>

<style lang="scss">
.pagination {
  width: 100%;
  color: $color-cool-grey-500;

  .page-box {
    display: flex;
    justify-content: center;

    .page-input{
      width: $space-3xl;
      margin-top: -8px;
      border-radius: $space-xs;
      text-align: center;
      border: 1px solid $color-cool-grey-300;
    }
  }
}
</style>